import { useMemoOne } from 'use-memo-one';
import type { AxiosHookConfig } from 'src/hooks/use-axios';
import { useReauthenticate } from 'src/hooks/use-reauthenticate';
import { handleErrorWithNotification } from 'src/utils/handle-error';

export function useCustomAxiosConfig() {
  const [_, setReauthenticate] = useReauthenticate();

  const axiosHookConfig = useMemoOne<AxiosHookConfig>(
    () => ({
      onError(error, meta) {
        // let error boundary handle errors from eager requests: the very first request when flagged as neededOnPageLoad: true
        if (meta.isPageLoadError) throw error;

        handleErrorWithNotification({
          error,
          setReauthenticate,
        });
      },
      cache: new Map(),
    }),

    []
  );

  return axiosHookConfig;
}
